import * as types from "../constants/ShootsActionTypes";

//fetching
export const fetchingShoot = () => ({
  type: types.SHOOT_FETCHING
});
//fetched
export const shootFetched = () => ({
  type: types.SHOOT_FETCHED
});
//failed
export const shootFailedFetch = () => ({
  type: types.SHOOT_FETCH_FAILED
});
//get shoots
export const getAllShoot = () => ({
  type: types.SHOOTS_GET_ALL
});

export const getAllShootSuccess = () => ({
  type: types.SHOOTS_GET_ALL_SUCCESS
});

export const getOneShoot = (clinic, created_at) => ({
  type: types.SHOOTS_GET_ONE,
  clinic,
  created_at
});

export const getOneShootSuccess = () => ({
  type: types.SHOOTS_GET_ONE_SUCCESS
});

export const getShootShots = shot_type => ({
  type: types.SHOOTS_GET_SHOTS,
  shot_type
});

export const getAllShootShots = (clinic, created_at, shot_type) => {
  return {
    type: types.SHOOTS_GET_SHOTS,
    clinic,
    created_at,
    shot_type
  };
};

export const updateShotPriority = (shot_type, id, priority, newPriority, clinic, created_at) => {
  return {
    type: types.SHOOT_UPDATE_SHOT_PRIORITY,
    shot_type,
    id,
    priority,
    newPriority,
    clinic,
    created_at
  };
};

//save shoots
export const saveShoot = () => ({
  type: types.SHOOTS_SAVE_SHOOT
});
//delete shoots
export const deleteShoot = () => ({
  type: types.SHOOTS_DELETE_SHOOT
});

//start shoot
export const startShoot = (clinic, created_at, body) => {
  return {
    type: types.SHOOTS_START,
    clinic,
    created_at,
    body
  };
};

export const openStartShootDialog = () => {
  return {
    type: types.SHOOTS_START_DIALOG_OPEN
  };
};

export const closeStartShootDialog = () => {
  return {
    type: types.SHOOTS_START_DIALOG_CLOSE
  };
};

//DELETES
export const removeShotsFromShoot = (clinic, created_at, shot_type) => {
  return {
    type: types.SHOOTS_REMOVE_SHOTS,
    clinic,
    created_at,
    shot_type
  };
};

//others
export const handleCheckbox = (index, shot_type, selectedAll) => {
  return {
    type: types.SHOOTS_HANDLE_CHECKBOX,
    index,
    shot_type,
    selectedAll
  };
};

export const handleSelectAllCheckbox = shot_type => {
  return {
    type: types.SHOOTS_HANDLE_CHECKBOX_ALL,
    shot_type
  };
};

export const handleApproveShots = (clinic, created_at, shot_type, data) => {
  console.log("Approve Action");
  return {
    type: types.SHOOTS_CHECK_APPROVE,
    clinic,
    created_at,
    shot_type,
    data
  };
};

export const handleRejectShots = (clinic, created_at, shot_type, data) => {
  console.log("Approve Action");
  return {
    type: types.SHOOTS_CHECK_REJECT,
    clinic,
    created_at,
    shot_type,
    data
  };
};

export const markShootComplete = (clinic, created_at, shoot) => {
  return {
    type: types.SHOOTS_MARK_SHOOT_COMPLETE,
    clinic,
    created_at,
    shoot
  };
};

export const getShootStatus = (clinic, created_at) => {
  return {
    type: types.SHOOT_GET_STATUS,
    clinic,
    created_at
  };
};

//questions
export const getShootQuestions = (clinic, created_at) => {
  return {
    type: types.SHOOT_GET_QUESTION,
    clinic,
    created_at
  };
};

export const handleShootQuestionCheckbox = id => {
  return {
    type: types.SHOOT_QUESTION_HANDLE_CHECKBOX,
    id
  };
};

export const resetSelectedQuestions = () => {
  return {
    type: types.SHOOT_QUESTION_RESET_SELECTEDQUESTIONS
  };
};

export const setSelectedQuestions = selectedQuestions => {
  return {
    type: types.SHOOT_QUESTION_SET_SELECTEDQUESTIONS,
    selectedQuestions
  };
};

export const removeQuestionsFromShoot = (clinic, created_at) => {
  return {
    type: types.SHOOT_QUESTION_REMOVE,
    clinic,
    created_at
  };
};

export const getShootPackage = (clinic, created_at, shot_type) => {
  return {
    type: types.SHOOT_GET_PACKAGES,
    clinic,
    created_at,
    shot_type
  };
};
